<template>
  <el-dialog :title="title" :visible.sync="modalShow">
    <el-form ref="form" :model="form" :rules="rules" size="small" label-width="100px">
      <el-form-item label="学员手机号" prop="phone">
        <el-input v-model="form.phone" placeholder="学员手机号" clearable maxlength="11"/>
      </el-form-item>
      <el-form-item label="昵称" prop="nickname">
        <el-input v-model="form.nickname" placeholder="昵称" clearable maxlength="50"/>
      </el-form-item>
      <el-form-item label="学员姓名" prop="realname">
        <el-input v-model="form.realname" placeholder="请输入学员姓名" clearable maxlength="50"/>
      </el-form-item>
      <el-form-item label="证件类型" prop="type">
        <el-select
          style="width: 100%"
          v-model="form.type"
          placeholder="请选择"
        >
          <el-option label="身份证" :value="1" />
          <el-option label="港澳台身份证" :value="2" />
          <el-option label="港澳台通行证" :value="3" />
        </el-select>
      </el-form-item>
      <el-form-item label="学员证件号" prop="cardNo">
        <el-input v-model="form.cardNo" placeholder="请输入学员证件号" clearable maxlength="50"/>
      </el-form-item>
      <el-form-item label="学员证件照" prop="cardImg">
        <PictureUpload v-model="cardImgs" :limit="1" />
      </el-form-item>
      <el-form-item label="职业" prop="occupation">
        <el-input v-model="form.occupation" placeholder="请输入职业" clearable maxlength="50"/>
      </el-form-item>
      <el-form-item label="工作单位" prop="workCompany">
        <el-input v-model="form.workCompany" placeholder="请输入工作单位" clearable maxlength="50"/>
      </el-form-item>
      <el-form-item label="常驻地" prop="usualResidence">
        <el-input v-model="form.usualResidence" placeholder="请输入常驻地" clearable maxlength="50"/>
      </el-form-item>
      <el-form-item label="账号名称" prop="accName">
        <el-input v-model="form.accName" placeholder="请输入账号名称" clearable maxlength="50"/>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small" @click="modalShow = false">取消</el-button>
      <el-button type="primary" size="small" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import PictureUpload from "@/components/pictureUpload.vue"
import { addressJSON } from "@/utils/cityJson.js";
import { addAppUserInfo, saveUserData } from "@/api/product/base"

const xueliData = [
  { id: 1, name: "高中及以下" },
  { id: 2, name: "专科" },
  { id: 3, name: "本科" },
  { id: 4, name: "硕士" },
  { id: 5, name: "博士" },
  { id: 6, name: "博士后" }
]

const zhanghaoStatus = [
  { id: 1, name: "正常" },
  { id: 2, name: "冻结" },
]
const sexData = [
  { id: 1, name: "男" },
  { id: 2, name: "女" },
]

const rules = {
  phone: [
    { required: true, message: "请输入手机号", trigger: "blur" },
    { pattern: /^1[2-9]\d{9}$/, message: "请输入正确格式手机号", trigger: "blur" },
  ],
  receiverPhone: [
    { pattern: /^1[2-9]\d{9}$/, message: "请输入正确格式手机号", trigger: "blur" },
  ]
}
export default {
  components: { PictureUpload },
  data () {
    return {
      props: {
        value: "name",
        label: "name",
        children: "cityList",
      },
      options: addressJSON,
      modalShow: false,
      rules,
      xueliData,
      zhanghaoStatus,
      sexData,
      title: "添加学员",
      form: {
        phone: null,
        nickname: null,
        nickname: null,
        realname: null,
        type: null,
        cardNo: null,
        cardImg: '',
        occupation: null,
        workCompany: null,
        usualResidence: null,
        accName: null,
        receiver: [],
        receiverName: null,
        receiverProvinceName: null,
        receiverCityName: null,
        receiverRegionName: null,
        receiverDetailAddress: null,
        receiverPhone: null
      },
      cardImgs: [],
      id: null
    }
  },
  methods: {
    init (item) {
      const defaultData = this.$options.data();
      this.form = defaultData.form
      if (!item) {
        this.title = '添加学员'
        this.id = null
      } else {
        this.title = '编辑学员'
        Object.keys(this.form).forEach(keys=>{
          if(item[keys]){
            this.form[keys] = item[keys]
          }
        })
        this.form.receiver = [item.receiverProvinceName, item.receiverCityName, item.receiverRegionName]
        if (this.form.cardImg) {
          this.cardImgs = [{ url: this.form.cardImg }]
        }
        this.id = item.id
      }
      this.modalShow = true
    },
    async submit () {
      if (this.cardImgs.length !== 0) {
        this.form.cardImg = this.cardImgs[0].url
      }
      this.$refs.form.validate(async (valid) => {
        if (!valid) return
        if (!this.id) {
          const params = {
            ...this.form
          }
          if(params.receiver.length > 0){
            params.receiverProvinceName = params.receiver[0];
            params.receiverCityName = params.receiver[1];
            params.receiverRegionName = params.receiver[2];
          }
          delete params.receiver
          const res = await addAppUserInfo(params)
          if (res.code !== 0) {
            this.$message.error(res.message)
            return
          }
          this.modalShow = false
          this.$message.success('操作成功！')
          this.$emit('update', true)
        } else {
          const params = {
            ...this.form
          }
          if(params.receiver.length > 0){
            params.receiverProvinceName = params.receiver[0];
            params.receiverCityName = params.receiver[1];
            params.receiverRegionName = params.receiver[2];
          }
          delete params.receiver
          params.id = this.id
          const res = await saveUserData(params)
          if (res.code !== 0) {
            this.$message.error(res.message)
            return
          }
          this.modalShow = false
          this.$message.success('操作成功！')
          this.$emit('update', true)
        }

      })
    },
  }
}
</script>

<style>
</style>
